module.exports = __webpack_public_path__ + "img/x.fe9c2a32.svg";